import { Component, Input, OnInit } from '@angular/core';
import {SvgIconComponent} from "angular-svg-icon";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-reference-title',
  templateUrl: './reference-title.component.html',
  standalone: true,
  imports: [
    SvgIconComponent,
    NgIf
  ],
  styleUrl: './reference-title.component.scss'
})
export class ReferenceTitleComponent implements OnInit {
  @Input() data: any;
  @Input() column: any;

  constructor() {
  }

  ngOnInit(): void {
  }
}
